// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating-widget-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: transparent;
}

.floating-chat-widget {
  position: fixed;
  top: -3px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  transition: top 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.floating-chat-widget:not(.expanded):hover {
  top: 0;
}

.floating-chat-widget-collapsed {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #5616ea;
  background: linear-gradient(135deg, #4510b0 0%, #5616ea 100%);
  color: white;
  cursor: pointer;
  padding: 7px 10px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: background-color 0.5s ease, box-shadow 0.35s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform;
  backface-visibility: hidden;
}

.collapsed-icon {
  font-size: 14px;
}

.floating-chat-widget-collapsed:hover {
  background-color: #4d15cc;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
}

.vertical-text {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.floating-chat-widget-expanded {
  background-color: white;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  min-width: 280px;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  animation: expandWidget 0.3s ease-out;
  transform-origin: top center;
}

@keyframes expandWidget {
  from {
    opacity: 0;
    transform: scaleY(0);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}

.widget-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e8e8e8;
  background-color: #5616ea;
  background: linear-gradient(135deg, #4510b0 10%, #5616ea 100%);
  color: white;
}

.widget-header span {
  font-weight: 600;
  font-size: 16px;
}

.close-widget-btn {
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.5s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform;
  backface-visibility: hidden;
}

.close-widget-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.widget-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.widget-select-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.widget-bot-select-item.Mui-selected {
  background-color: #5616ea !important;
  color: white !important;
}

.widget-bot-select-item.Mui-selected:hover {
  background-color: #4a14d6 !important;
}

.widget-bot-select-item:hover {
  background-color: #e0f7fa;
}

.widget-test-btn {
  background-color: #5616ea;
  color: white;
  border: none;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background-color 0.5s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform;
  backface-visibility: hidden;
}

.widget-test-btn:hover:not(:disabled) {
  background-color: #4d15cc;
  transform: translateY(-1px);
}

.widget-test-btn:active:not(:disabled) {
  transform: translateY(0);
}

.widget-test-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

.widget-loading,
.widget-empty {
  text-align: center;
  padding: 20px;
  color: #666;
  font-size: 14px;
}

.widget-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

@media (max-width: 768px) {
  .floating-chat-widget-expanded {
    min-width: 260px;
    max-width: 280px;
  }

  .vertical-text {
    font-size: 12px;
  }

  .floating-chat-widget-collapsed {
    padding: 6px 10px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/floatingChatWidget.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,yCAAyC;EACzC,mHAAmH;EACnH,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,oBAAoB;EACtB;EACA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,yBAAyB;EACzB,8DAA8D;EAC9D,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4FAA4F;EAC5F,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,4FAA4F;EAC5F,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".floating-widget-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 999;\r\n  background-color: transparent;\r\n}\r\n\r\n.floating-chat-widget {\r\n  position: fixed;\r\n  top: -3px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 1000;\r\n  transition: top 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n.floating-chat-widget:not(.expanded):hover {\r\n  top: 0;\r\n}\r\n\r\n.floating-chat-widget-collapsed {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  background-color: #5616ea;\r\n  background: linear-gradient(135deg, #4510b0 0%, #5616ea 100%);\r\n  color: white;\r\n  cursor: pointer;\r\n  padding: 7px 10px;\r\n  border-bottom-left-radius: 8px;\r\n  border-bottom-right-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n  transition: background-color 0.5s ease, box-shadow 0.35s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.collapsed-icon {\r\n  font-size: 14px;\r\n}\r\n\r\n.floating-chat-widget-collapsed:hover {\r\n  background-color: #4d15cc;\r\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.vertical-text {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  letter-spacing: 1px;\r\n  user-select: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n.floating-chat-widget-expanded {\r\n  background-color: white;\r\n  border-bottom-left-radius: 8px;\r\n  border-bottom-right-radius: 8px;\r\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);\r\n  min-width: 280px;\r\n  max-width: 320px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  animation: expandWidget 0.3s ease-out;\r\n  transform-origin: top center;\r\n}\r\n\r\n@keyframes expandWidget {\r\n  from {\r\n    opacity: 0;\r\n    transform: scaleY(0);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scaleY(1);\r\n  }\r\n}\r\n\r\n.widget-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 16px;\r\n  border-bottom: 1px solid #e8e8e8;\r\n  background-color: #5616ea;\r\n  background: linear-gradient(135deg, #4510b0 10%, #5616ea 100%);\r\n  color: white;\r\n}\r\n\r\n.widget-header span {\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n}\r\n\r\n.close-widget-btn {\r\n  background: transparent;\r\n  border: none;\r\n  color: white;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 4px;\r\n  transition: background-color 0.5s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.close-widget-btn:hover {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n  transform: scale(1.1);\r\n}\r\n\r\n.widget-content {\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.widget-select-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.widget-bot-select-item.Mui-selected {\r\n  background-color: #5616ea !important;\r\n  color: white !important;\r\n}\r\n\r\n.widget-bot-select-item.Mui-selected:hover {\r\n  background-color: #4a14d6 !important;\r\n}\r\n\r\n.widget-bot-select-item:hover {\r\n  background-color: #e0f7fa;\r\n}\r\n\r\n.widget-test-btn {\r\n  background-color: #5616ea;\r\n  color: white;\r\n  border: none;\r\n  padding: 8px 10px;\r\n  border-radius: 6px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  transition: background-color 0.5s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.widget-test-btn:hover:not(:disabled) {\r\n  background-color: #4d15cc;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.widget-test-btn:active:not(:disabled) {\r\n  transform: translateY(0);\r\n}\r\n\r\n.widget-test-btn:disabled {\r\n  background-color: #ccc;\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n  transform: none;\r\n}\r\n\r\n.widget-loading,\r\n.widget-empty {\r\n  text-align: center;\r\n  padding: 20px;\r\n  color: #666;\r\n  font-size: 14px;\r\n}\r\n\r\n.widget-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .floating-chat-widget-expanded {\r\n    min-width: 260px;\r\n    max-width: 280px;\r\n  }\r\n\r\n  .vertical-text {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .floating-chat-widget-collapsed {\r\n    padding: 6px 10px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
